import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { KEYS } from '../../constants/keys.js';

var getElementOwner = function getElementOwner(el) {
  return el && el.ownerDocument || document;
};
var isElementDisabled = function isElementDisabled(el) {
  return el && (el.getAttribute("disabled") === "true" || el.getAttribute("aria-disabled") === "true");
};
var getNodeAsElement = function getNodeAsElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE ? node : void 0;
};
var getActiveItem = function getActiveItem(list, items) {
  var owner = getElementOwner(list);
  var focused = getNodeAsElement(owner.activeElement);
  if (!focused) return;
  return items[items.indexOf(focused)];
};
var getNextItem = function getNextItem(items, item, reverse) {
  if (!item) return;
  var itemIndex = items.indexOf(item);
  if (itemIndex === -1) return;
  var sibling = items[reverse ? itemIndex - 1 : itemIndex + 1];
  var disabled = isElementDisabled(sibling);
  if (item && sibling && !disabled) {
    return sibling;
  }
  if (item && sibling && disabled) {
    return getNextItem(items, sibling, reverse);
  }
  if (item && !sibling) {
    var child = reverse ? items[items.length - 1] : items[0];
    return isElementDisabled(child) ? getNextItem(items, child, reverse) : getNodeAsElement(child);
  }
};
var getFirstItem = function getFirstItem(items) {
  return getNextItem(items, items[items.length - 1]);
};
var moveItem = function moveItem(item, e) {
  if (!item) return;
  item.focus();
  e === null || e === void 0 ? void 0 : e.preventDefault();
};
var handleNavKeys = function handleNavKeys(e, items, item) {
  if (!item) return;
  var nextItem;
  switch (e.key) {
    case KEYS.ARROW_UP:
      {
        nextItem = getNextItem(items, item, true);
        break;
      }
    case KEYS.ARROW_DOWN:
      {
        nextItem = getNextItem(items, item);
        break;
      }
    case KEYS.HOME:
      {
        nextItem = getFirstItem(items);
        break;
      }
    case KEYS.END:
      {
        nextItem = getNextItem(items, getNodeAsElement(items[0]), true);
        break;
      }
  }
  moveItem(nextItem, e);
};
var handleSearchKeys = function handleSearchKeys(e, items, item) {
  if (Object.entries(KEYS).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[1];
    return e.key === key;
  })) return;
  if (!item) return;
  var nextItem;
  var match;
  while (!match && (!nextItem || nextItem !== item)) {
    var _nextItem, _nextItem2;
    nextItem = getNextItem(items, nextItem || item);
    var innerText = (_nextItem = nextItem) === null || _nextItem === void 0 ? void 0 : _nextItem.innerText;
    var textContent = ((_nextItem2 = nextItem) === null || _nextItem2 === void 0 ? void 0 : _nextItem2.textContent) || "";
    var text = innerText ? innerText : textContent;
    match = text.toLowerCase().startsWith(e.key.toLowerCase());
  }
  moveItem(nextItem);
};

export { getActiveItem, getElementOwner, getFirstItem, getNodeAsElement, handleNavKeys, handleSearchKeys, isElementDisabled, moveItem };
